import { getField } from "@joandvgv/vuex-map-fields";
import { PLAN_NAMES } from "@Shared/@Utils/constants";
export const CURRENT_USER_DETAILS = "CURRENT_USER_DETAILS";
export const CURRENT_USER_USERNAME = "CURRENT_USER_USERNAME";
export const CURRENT_ACCOUNT_DETAILS = "CURRENT_ACCOUNT_DETAILS";
export const CURRENT_ACCOUNT_PREFERENCES = "CURRENT_ACCOUNT_PREFERENCES";
export const LOCALE = "LOCALE";
export const IS_LOCALE_EN = "IS_LOCALE_EN";
export const ACCOUNT_PLAN = "ACCOUNT_PLAN";
export const ACCOUNT_PLAN_IS_FREE = "ACCOUNT_PLAN_IS_FREE";
export const PLAN_EXPIRATION = "PLAN_EXPIRATION";
export const SHOULD_SHOW_WELCOME_PLAN_BANNER = "SHOULD_SHOW_WELCOME_PLAN_BANNER";
export const LAST_LOGIN_DATE = "LAST_LOGIN_DATE";
export const ACCOUNT_STATUS = "ACCOUNT_STATUS";
export const SHOULD_SHOW_PAYMENT_FAILED_BANNER = "SHOULD_SHOW_PAYMENT_FAILED_BANNER";
export const APPLICATION_NOTIFICATION_FREQUENCY = "APPLICATION_NOTIFICATION_FREQUENCY";
export const ACCOUNT_EMAIL_SIGNATURE = "ACCOUNT_EMAIL_SIGNATURE";
export const CURRENT_ACCOUNT_PLAN = "CURRENT_ACCOUNT_PLAN";
export const ACCOUNT_EXPIRATION_DATE = "ACCOUNT_EXPIRATION_DATE";
export const CURRENT_BROKERAGE_DETAILS = "CURRENT_BROKERAGE_DETAILS";
export const REFERRAL_SOURCE_ENABLED = "REFERRAL_SOURCE_ENABLED";
export const GET_REFERRAL_API_PARTNERS = "GET_REFERRAL_API_PARTNERS";
export const CURRENT_ACCOUNT_IS_BROKER = "CURRENT_ACCOUNT_IS_BROKER";
export const GET_REPORT_DEFAULT_SETTINGS = "GET_REPORT_DEFAULT_SETTINGS";
export const GET_MPP_GENERATE = "GET_MPP_GENERATE";
export const CURRENT_ACCOUNT_ACCESS_RIGHTS = "CURRENT_ACCOUNT_ACCESS_RIGHTS";
export const CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY = "CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY";
export const CURRENT_ACCOUNT_AUTHORIZED = "CURRENT_ACCOUNT_AUTHORIZED";
export const GET_AI_EMAILS_DEFAULT_SETTINGS = "GET_AI_EMAILS_DEFAULT_SETTINGS";
const getters = {
  getField,
  [CURRENT_USER_DETAILS]: state => {
    return state.userDetails;
  },
  [CURRENT_BROKERAGE_DETAILS]: state => {
    return state.brokerageDetails;
  },
  [CURRENT_USER_USERNAME]: (state, getters) => {
    const {
      username
    } = getters.CURRENT_USER_DETAILS;
    return username;
  },
  [CURRENT_ACCOUNT_DETAILS]: state => {
    return state.accountDetails;
  },
  [CURRENT_ACCOUNT_ACCESS_RIGHTS]: state => {
    var _state$accountDetails;
    return ((_state$accountDetails = state.accountDetails) == null ? void 0 : _state$accountDetails.accessRights) || {};
  },
  [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY]: state => {
    var _state$accountDetails2, _state$accountDetails3;
    return ((_state$accountDetails2 = state.accountDetails) == null ? void 0 : (_state$accountDetails3 = _state$accountDetails2.accessRights) == null ? void 0 : _state$accountDetails3.viewOnly) || false;
  },
  [CURRENT_ACCOUNT_AUTHORIZED]: state => {
    var _state$accountDetails4;
    return ((_state$accountDetails4 = state.accountDetails) == null ? void 0 : _state$accountDetails4.authorized) || false;
  },
  [CURRENT_ACCOUNT_PREFERENCES]: state => {
    return state.accountPreferences;
  },
  [LOCALE]: state => {
    var _state$accountDetails5;
    return ((_state$accountDetails5 = state.accountDetails.localeLanguage) == null ? void 0 : _state$accountDetails5.replace("-CA", "")) || "en";
  },
  [IS_LOCALE_EN]: (state, getters) => {
    return getters["LOCALE"] === "en";
  },
  [LAST_LOGIN_DATE]: state => {
    return state.accountDetails.lastLoggedIn || null;
  },
  [ACCOUNT_PLAN]: state => {
    return state.accountDetails.accountPlan;
  },
  [ACCOUNT_STATUS]: state => {
    return state.accountDetails.accountStatus;
  },
  [PLAN_EXPIRATION]: state => {
    return state.accountDetails.expirationDate;
  },
  [ACCOUNT_PLAN_IS_FREE]: (state, getters) => {
    return getters["ACCOUNT_PLAN"] === PLAN_NAMES.FREE && !getters["PLAN_EXPIRATION"];
  },
  [SHOULD_SHOW_WELCOME_PLAN_BANNER]: (state, getters) => {
    return getters["ACCOUNT_PLAN"] === PLAN_NAMES.FREE && !getters["LAST_LOGIN_DATE"];
  },
  [SHOULD_SHOW_PAYMENT_FAILED_BANNER]: (state, getters, rootState, rootGetters) => {
    return getters["ACCOUNT_STATUS"] === "payment-failed" && rootGetters["AccountPlanStore/HAS_PAYMENT_ERROR"];
  },
  [APPLICATION_NOTIFICATION_FREQUENCY]: state => {
    return state.accountPreferences.applicationNotificationFrequency || 0;
  },
  [ACCOUNT_EMAIL_SIGNATURE]: state => {
    return state.accountPreferences.emailSignature;
  },
  [CURRENT_ACCOUNT_PLAN]: state => {
    return state.accountDetails.accountPlan;
  },
  [ACCOUNT_EXPIRATION_DATE]: state => {
    return state.accountDetails.expirationDate;
  },
  [REFERRAL_SOURCE_ENABLED]: state => {
    var _brokerage$referralSo;
    const [brokerage] = state.brokerageDetails.tiedBrokerages;
    return (_brokerage$referralSo = brokerage.referralSourceEnabled) != null ? _brokerage$referralSo : false;
  },
  [GET_REFERRAL_API_PARTNERS]: state => {
    const [brokerage] = state.brokerageDetails.tiedBrokerages;
    return brokerage.referralApiPartners || {};
  },
  [CURRENT_ACCOUNT_IS_BROKER]: state => {
    return state.accountDetails.accountType === "broker";
  },
  [GET_REPORT_DEFAULT_SETTINGS]: state => {
    return state.accountPreferences.reportDefaultSettings;
  },
  [GET_MPP_GENERATE]: state => {
    return state.accountDetails.mppGenerate;
  },
  [GET_AI_EMAILS_DEFAULT_SETTINGS]: state => {
    return state.accountPreferences.aiEmailDefaultSettings;
  }
};
export default getters;